import CatalogInformation from './cataloginformation'

export default CatalogInformation
